/* eslint-disable no-underscore-dangle */
import { loadJs } from '@liepin/js-core4c-fe';

window.__tlogRouterListener = true;
window.__delayTlog = true;

export default function initTlog(tlg, ignoreLoadTlod = false) {
  if (tlg) {
    window.tlg = tlg;
  }
  if (!(window.tlog && window.tlog.version) && !ignoreLoadTlod) {
    loadJs('//concat.lietou-static.com/fe-lib-pc/v5/tlog/tlog.min.js')
  }
}
